const className = Modernizr.mobile && Modernizr.touchevents ? 'touch' : 'hover';

const selector = [
    '.js-hover',
    '.btn',
    '.document',
    '.social-icon',
    '.add-action',
    '.js-remove-action',
].join(',');

$(document)
    .on(NLMK.MOUSEENTER_EVENT, selector, evt => {
        $(evt.currentTarget).addClass(className)
    })
    .on(NLMK.MOUSELEAVE_EVENT, selector, evt => {
        $(evt.currentTarget).removeClass(className)
    })
;



// WEBPACK FOOTER //
// ./js/main/module/events.js